// Card de um campo S/O/P (a Avaliação tem componente próprio — Regra 7). Cabeçalho
// cinza com a letra, título, contagem de incertezas (derivada do texto) e "Copiar".
// Corpo = TextoComMarcadores (editável, âmbar no [?]).

import type { CSSProperties } from 'react';

import { contarMarcadores } from '../../lib/marcadores';
import { cor, fonte } from '../../styles/tokens';
import { CopiarBotao } from './CopiarBotao';
import { TextoComMarcadores } from './TextoComMarcadores';

const cabecalho: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '7px 12px',
  borderBottom: `1px solid ${cor.linhaFraca}`,
  background: cor.cabecalhoCampo,
};

const letraStyle: CSSProperties = { fontFamily: fonte.mono, fontSize: 12, color: cor.azul };

const tituloStyle: CSSProperties = {
  fontFamily: fonte.condensada,
  fontWeight: 600,
  fontSize: 16,
  letterSpacing: '.1em',
  textTransform: 'uppercase',
};

const contadorStyle: CSSProperties = {
  fontFamily: fonte.mono,
  fontSize: 10,
  color: cor.muted,
  letterSpacing: '.1em',
};

interface Props {
  letra: 'S' | 'O' | 'P';
  titulo: string;
  valor: string;
  onChange: (valor: string) => void;
  containerStyle?: CSSProperties;
}

export function CampoSoap({ letra, titulo, valor, onChange, containerStyle }: Props): JSX.Element {
  const n = contarMarcadores(valor);
  return (
    <div
      style={{
        border: `1px solid ${cor.linhaForte}`,
        background: cor.branco,
        display: 'flex',
        flexDirection: 'column',
        ...containerStyle,
      }}
    >
      <div style={cabecalho}>
        <span style={letraStyle}>{letra}</span>
        <span style={tituloStyle}>{titulo}</span>
        <span style={{ marginLeft: 'auto' }} />
        {n > 0 && (
          <span style={contadorStyle}>
            {n} {n === 1 ? 'INCERTEZA' : 'INCERTEZAS'}
          </span>
        )}
        <CopiarBotao texto={valor} rotulo={`Copiar ${letra}`} />
      </div>
      <TextoComMarcadores valor={valor} onChange={onChange} />
    </div>
  );
}
